import React, { useState } from 'react';
import { Grid, IconButton, Box, CircularProgress } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from '../../Components/Sidebar';

const AdminAppSettings = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // 👇 Always true for now
  const loading = true;

  return (
    <Grid container style={{ height: '100vh', overflow: 'hidden' }}>
      {/* ✅ Navbar toggle button (always rendered, independent of sidebar state) */}
      <IconButton
        onClick={() => setSidebarOpen(true)}
        sx={{
          position: 'fixed',
          marginTop: '64px',
          left: '16px',
          zIndex: 1300,
        }}
      >
        <MenuIcon style={{ color: 'black' }} />
      </IconButton>

      {/* ✅ Sidebar is controlled by state but main content is always rendered */}
      <Sidebar
        isOpen={sidebarOpen}
        currentPage="admin-settings"
        onClose={() => setSidebarOpen(false)}
        sidebarOpen={sidebarOpen}
        isAdminAuthenticated={true}
        sx={{
          width: sidebarOpen ? '20%' : '0',
          transition: 'width 0.3s ease',
          '@media (max-width: 600px)': {
            width: sidebarOpen ? '100%' : '0',
          },
        }}
      />

      {/* ✅ Main Content Area - ALWAYS mounted */}
      <Grid
        item
        xs
        style={{
          height: '100vh',
          marginLeft: sidebarOpen ? '24%' : '0',
          width: sidebarOpen ? '50%' : '100%',
          transition: 'all 0.3s ease',
          backgroundColor: '#f5f5f5',
          position: 'relative', // needed for overlay positioning
          overflow: 'hidden',
        }}
      >
        {/* Here is your permanent loading overlay */}
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.15)',
              backdropFilter: 'blur(4px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 2, // sits on top of content
            }}
          >
            <CircularProgress size={80} sx={{ color: '#3B2673' }} />
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default AdminAppSettings;
